module.exports = __webpack_public_path__ + "static/media/Library.12b4f256.png";